module.exports = __webpack_public_path__ + "img/slideshow-quatrieme-couverture-lpdm.31402c30.png";